import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import React from "react"
import { europcarCompaniesFilter, europcarSitesFilter, europcarUsersFilter } from "Pages/BusinessLogistics/Analytics/Page/@signals"

export default function EuropcarSiteSelector() {

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		urlAjax={`${BACKEND_APIS.EUROPCAR_ANALYTICS}/sites`}
		value={europcarSitesFilter.value}
		onChange={(e => europcarSitesFilter.value = e.target.value)}
		label="Sites"
		placeholder="Select a site to filter"
		filters={{
			company: europcarCompaniesFilter.value,
			uid: europcarUsersFilter.value,
		}}
	/>
}